import { useSelector } from 'react-redux';

// import useHasPermission from '../../helpers/hooks/useHasPermission';

import Button from '../Button.react';
import Input from '../form/Input.react';
var CardHeader = function CardHeader(_ref) {
  var _permissions$find;
  var title = _ref.title,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? null : _ref$button,
    _ref$search = _ref.search,
    search = _ref$search === void 0 ? null : _ref$search;
  var permissions = useSelector(function (s) {
    var _s$auth, _s$auth$user;
    return ((_s$auth = s.auth) === null || _s$auth === void 0 ? void 0 : (_s$auth$user = _s$auth.user) === null || _s$auth$user === void 0 ? void 0 : _s$auth$user.permissions) || [];
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "card-header__actions"
  }, search && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "card-header__actions--label"
  }, search === null || search === void 0 ? void 0 : search.label), /*#__PURE__*/React.createElement(Input, {
    value: search === null || search === void 0 ? void 0 : search.query,
    onChange: search === null || search === void 0 ? void 0 : search.onChange,
    placeholder: search === null || search === void 0 ? void 0 : search.placeholder,
    className: "card-header__actions--input"
  })), button && !button.disabled && (!button.permission || ((_permissions$find = permissions.find(function (x) {
    return x.key === (button === null || button === void 0 ? void 0 : button.permission);
  })) === null || _permissions$find === void 0 ? void 0 : _permissions$find.value) === true) && /*#__PURE__*/React.createElement(Button, {
    label: button.label,
    onClick: function onClick() {
      if (button.onClick) button.onClick();
    },
    type: button.type || '',
    apiID: button.apiID,
    requireConfirmation: button.requireConfirmation || false
  })));
};
export default CardHeader;